import { LoaderButton, useFetchAuth } from '@kaiku/ui'
import { Button, Container, Dialog, DialogActions, DialogTitle, FormHelperText, makeStyles, TextField } from '@material-ui/core'
import { bool, func, string } from 'prop-types'
import React, { useState } from 'react'

import { getReferralCodeUrl } from '../../api'

const useStyles = makeStyles( {
  container: {
    marginTop: '0.2em',
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
      marginBottom: '0.1em',
    },
  },
} )

const UpdateReferralDialog = ( { open, onClose, onEdit, code, currentDesc } ) => {
  const [ error, setError ] = useState()
  const [ submitting, setSubmitting ] = useState( false )
  const fetch = useFetchAuth()
  const [ description, setDescription ] = useState()
  const classes = useStyles()

  const updateDescription = () => {
    setError()
    setSubmitting( true )
    fetch( getReferralCodeUrl(), { method: 'PATCH', body: { code, description } } )
      .then( onEdit )
      .catch( ( e ) => {
        setError( e.message )
      } )
      .finally( () => setSubmitting( false ) )
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Update referral description</DialogTitle>

      <Container className={classes.container}>
        <span>Please enter the new description.</span>
        <TextField label="Code" defaultValue={code} disabled />
        <TextField label="Description" defaultValue={currentDesc} onChange={( e ) => setDescription( e.target.value )} />
        <FormHelperText error>
          {error}
        </FormHelperText>
      </Container>

      <DialogActions>
        <Button onClick={onClose} variant="text" color="primary">Cancel</Button>
        <LoaderButton loading={submitting} onClick={updateDescription} color="primary" disabled={!code || !description}>Update</LoaderButton>
      </DialogActions>

    </Dialog>
  )
}

UpdateReferralDialog.propTypes = {
  open: bool,
  onClose: func.isRequired,
  onEdit: func.isRequired,
  code: string,
  currentDesc: string,
}

UpdateReferralDialog.defaultProps = {
  open: false,
  code: '',
  currentDesc: '',
}

export default UpdateReferralDialog
